/**
 * Debug logging for the embed runtime.
 *
 * The widget runs on customers' websites, so it stays silent in the console by
 * default. Turn logging on with `window.BOLDER_WIDGET_DEBUG = true` before the
 * script loads, or by adding `?bolder_debug=1` to the page URL.
 */

let cached: boolean | null = null;

export function isEmbedDebug(): boolean {
  if (cached !== null) return cached;
  try {
    cached =
      typeof window !== 'undefined' &&
      ((window as unknown as { BOLDER_WIDGET_DEBUG?: boolean }).BOLDER_WIDGET_DEBUG === true ||
        /[?&]bolder_debug=1\b/.test(window.location.search));
  } catch {
    cached = false;
  }
  return cached;
}

export function debugLog(...args: unknown[]): void {
  if (isEmbedDebug()) console.log(...args);
}
